import { render, staticRenderFns } from "./OnCallFieldOption.vue?vue&type=template&id=af49bfb0&scoped=true&"
import script from "./OnCallFieldOption.vue?vue&type=script&lang=js&"
export * from "./OnCallFieldOption.vue?vue&type=script&lang=js&"
import style0 from "./OnCallFieldOption.vue?vue&type=style&index=0&id=af49bfb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af49bfb0",
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput});
